import { createTransform } from 'redux-persist';

import { ITemplatesState } from '../../types/templates';
import { initialState } from '../reducers/templates';

const emailsTransform = createTransform(
  (stateIn: ITemplatesState) => stateIn,
  (stateOut: ITemplatesState) => {
    return {
      ...stateOut,
      emails: { ...stateOut.emails, error: null, isLoading: false },
    };
  },
  { whitelist: ['templates'] },
);

const notesTransform = createTransform(
  (stateIn: ITemplatesState) => stateIn,
  (stateOut: ITemplatesState) => {
    return {
      ...stateOut,
      notes: { ...stateOut.notes, error: null, isLoading: false },
    };
  },
  { whitelist: ['templates'] },
);

const templateDetailsTransform = createTransform(
  (stateIn: ITemplatesState) => stateIn,
  (stateOut: ITemplatesState) => {
    return {
      ...stateOut,
      templateDetails: { ...stateOut.templateDetails, error: null, isLoading: false },
    };
  },
  { whitelist: ['templates'] },
);

// Never rehydrate the claim-link template list or currentTemplate from localStorage: stale
// copies would shadow freshly saved server data on page load (useClaimLinkTemplate resolves
// from the list first and skips the fetch when it finds a match). The builder draft is the
// user's working copy, so it survives refresh along with its dirty-check snapshot and
// undo/redo history.
const claimLinksTransform = createTransform(
  (stateIn: ITemplatesState) => stateIn,
  (stateOut: ITemplatesState) => {
    return {
      ...stateOut,
      claimLinks: {
        ...initialState.claimLinks,
        draft: stateOut.claimLinks?.draft ?? null,
        draftSnapshot: stateOut.claimLinks?.draftSnapshot ?? null,
        pageHistory: stateOut.claimLinks?.pageHistory ?? initialState.claimLinks.pageHistory,
      },
    };
  },
  { whitelist: ['templates'] },
);

const transformArray = [templateDetailsTransform, notesTransform, emailsTransform, claimLinksTransform];

export default transformArray;
